// 検査日選択

import flatpickr from 'flatpickr/dist/flatpickr.min.js';
import { Japanese } from 'flatpickr/dist/l10n/ja.js';

let minDate = '2011-09-20';

const rmmAgri = document.querySelector('.pageRmmAgri');
const rmmProcessed = document.querySelector('.pageRmmProcessed');
const rmmMarine = document.querySelector('.pageRmmMarine');

if(rmmAgri) {
  minDate = '2011-09-20';
} else if(rmmProcessed) {
  minDate = '2011-10-27';
} else if(rmmMarine) {
  minDate = '2012-05-21';
}

flatpickr('#rmmDateStart', {
  locale: Japanese,
  dateFormat: 'Y年m月d日',
  defaultDate: '',
  minDate: minDate,
  maxDate: new Date(),
});

flatpickr('#rmmDateEnd', {
  locale: Japanese,
  dateFormat: 'Y年m月d日',
  defaultDate: '',
  minDate: minDate,
  maxDate: new Date(),
});

// 検索絞り込み

// 行の絞り込み
const kanaLineButtons = document.querySelectorAll('[data-kanaline]');
const kanaHeadGroups = document.querySelectorAll('.rmmSearchKanaGroup');

kanaLineButtons.forEach((kanaLineButton) => {
  kanaLineButton.addEventListener('click', kanaLineSort);
  kanaLineButton.addEventListener('click', selectSampleItem);
});

function kanaLineSort() {
  const kanaLineButtonsChecked = document.querySelectorAll('input[name="kanaLine[]"]:checked');

  // 一時的に行を全て非表示
  kanaHeadGroups.forEach((kanaHeadGroup) => {
    kanaHeadGroup.classList.remove('-active');
    if (kanaLineButtonsChecked.length === 0) {
      kanaHeadGroup.classList.remove('-hidden');
    } else {
      kanaHeadGroup.classList.add('-hidden');
    }
  });

  // 対象の行を表示
  kanaLineButtonsChecked.forEach((kanaLineButtonsCheck) => {
    const targetKanaLine = kanaLineButtonsCheck.dataset.kanaline;
    const targetKanaHead = document.querySelector('[data-kanahead="' + targetKanaLine + '"]');
    targetKanaHead.classList.add('-active');
  });
}


// 頭文字の絞り込み
const kanaHeadButtons = document.querySelectorAll('[data-kanaheadfilter]');

kanaHeadButtons.forEach((kanaHeadButton) => {
  kanaHeadButton.addEventListener('click', kanaHeadSort);
  kanaHeadButton.addEventListener('click', selectSampleItem);
});

function kanaHeadSort() {
  // 一時的に対象のアイテムを全て非表示
  const kanaParent = this.closest(".rmmSearchKanaGroup");
  const kanaData = kanaParent.dataset.kanahead;
  const kanaItemGroups = document.querySelectorAll('[data-kanahead="' + kanaData + '"] .rmmSearchSampleItem');

  const kanaHeadButtonsChecked = document.querySelectorAll('[data-kanahead="' + kanaData + '"] input[name="kanaHead[]"]:checked');

  kanaItemGroups.forEach((kanaItemGroup) => {
    kanaItemGroup.classList.remove('-active');
    if (kanaHeadButtonsChecked.length === 0) {
      kanaItemGroup.classList.remove('-hidden');
    } else {
      kanaItemGroup.classList.add('-hidden');
    }
  });

  // 対象の行を表示
  kanaHeadButtonsChecked.forEach((kanaHeadButtonsCheck) => {
    const targetKana = kanaHeadButtonsCheck.dataset.kanaheadfilter;
    const targetKanaItems = document.querySelectorAll('[data-kana="' + targetKana + '"]');
    targetKanaItems.forEach((targetKanaItem) => {
      targetKanaItem.classList.add('-active');
    });
  });
}


// 試料種別選択時

const kanaButtons = document.querySelectorAll('[name^="sampleItem[]"]');

kanaButtons.forEach((kanaButton) => {
  kanaButton.addEventListener('click', selectSampleItem);
});

function selectSampleItem() {
  const selectWordText = document.querySelector('#selectWordText');

  // 選択中の試料種別リセット
  const selectWordTextItems = selectWordText.querySelectorAll('span');
  if (selectWordTextItems) {
    selectWordTextItems.forEach((selectWordTextItem) => {
      selectWordTextItem.remove();
    });
  }

  const kanaLineCheckBoxes = document.querySelectorAll('[name="kanaLine[]"]:checked');
  const kanaHeadCheckBoxes = document.querySelectorAll('[name="kanaHead[]"]:checked');
  const sampleItemCheckBoxes = document.querySelectorAll('[name^="sampleItem[]"]:checked');

  // 選択中○○行取得
  kanaLineCheckBoxes.forEach((kanaLineCheckBox) => {
    if(kanaLineCheckBoxes.length != 0) {
      const targetKanaLine02 = kanaLineCheckBox.dataset.kanaline;

      if(kanaHeadCheckBoxes.length != 0 || sampleItemCheckBoxes.length != 0) {
        const sampleItemText = '[data-kanalinecat="' + targetKanaLine02 + '"]:checked';
        const sampleItemName = document.querySelector(sampleItemText);

        if(!sampleItemName) {
          const addSelectItem = document.createElement('span');
          addSelectItem.textContent = kanaLineCheckBox.value + '行';
          selectWordText.appendChild(addSelectItem);
        }
      } else {
        const addSelectItem = document.createElement('span');
        addSelectItem.textContent = kanaLineCheckBox.value + '行';
        selectWordText.appendChild(addSelectItem);
      }

    }
  });

  // 選択中頭文字「○○」取得
  kanaHeadCheckBoxes.forEach((kanaHeadCheckBox) => {
    if(kanaHeadCheckBoxes.length != 0) {
      const targetKanaHead02 = kanaHeadCheckBox.dataset.kanaheadfilter;

      if(sampleItemCheckBoxes.length != 0) {
        const sampleItemText = '[data-kanaheadcat="' + targetKanaHead02 + '"]:checked';
        const sampleItemName = document.querySelector(sampleItemText);
        if(!sampleItemName) {
          const addSelectItem = document.createElement('span');
          addSelectItem.textContent = '頭文字「' + kanaHeadCheckBox.value + '」';
          selectWordText.appendChild(addSelectItem);
        }
      } else {
        const addSelectItem = document.createElement('span');
        addSelectItem.textContent = '頭文字「' + kanaHeadCheckBox.value + '」';
        selectWordText.appendChild(addSelectItem);
      }

    }
  });

  // 選択中の試料種別の取得
  sampleItemCheckBoxes.forEach((sampleItemCheckBox) => {
    if(sampleItemCheckBox) {
      const addSelectItem = document.createElement('span');
      
      const array_value = sampleItemCheckBox.value.split(":");
      addSelectItem.textContent = sampleItemCheckBox.value;
      if(Array.isArray(array_value) && array_value[1]){
        addSelectItem.textContent = array_value[1];
      }
      selectWordText.appendChild(addSelectItem);
    }
  });
}